export default __webpack_public_path__ + "static/media/ConnectGNBIcon.80496dc0.svg";